export const SCOPE_KEYS = ["scope1", "scope2", "scope3"];

export const SCOPE_LABELS = {
  scope1: "Scope 1",
  scope2: "Scope 2",
  scope3: "Scope 3",
};
